import { PROVINCES } from '@/app/lib/constants'

/** Etiqueta canónica de un slug de provincia (`PROVINCES`), sin ningún
 * override de presentación por módulo — ver `LocationPickerProps.getLabel`. */
export function defaultLabelForLocation(slug: string): string {
  return PROVINCES.find((province) => province.slug === slug)?.label ?? slug
}
